import { mapEnumToOptions } from '@abp/ng.core';

export enum OperatorState {
  Inactive = 0,
  Active = 1,
}

export const operatorStateOptions = mapEnumToOptions(OperatorState);
